<template>
	<FunnelStepsBottomSheet
		ref="steps-bottom-sheet"
		:z-index="999"
		:can-transition="funnelStore.canTransition"
		:banner-data="bannerData"
		:stepperSteps="stepperSteps"
		:stepperProgress="funnelStore.stepperProgress"
		:active="activeStepsBottomSheet"
		@toggling-popup="togglingStepsSheet"
		@go-to-menu="goToMenu"
	>
		<template #products-registry="{item}">
			<AppPagination class="pagination" ref="registry-pagination" change-height hide-dots hide-header transparent :pages="registryPages">
				<template v-slot:ai-add-menu>
					<div class="row">
						<div class="col-6 mobile-12">
							<div class="row">
								<p><b>{{getString('ai_registry_title', [userStore.menuWord])}}</b></p>
								<div class="icon-ai ml-5" v-html="getIcon('iconAi')"></div>
							</div>
							<p v-html="getString('ai_registry_description', [userStore.menuWord])"></p>
							<div v-show="!funnelStore.pollingMenuUpload" class="desktop-menu-description">
								<p class="mt-30"><b>{{getString('ai_registry_manual', [userStore?.menuWord])}}</b></p>
								<p>{{getString('ai_registry_manual_cta')}} <span class="clickable-span" @click="changeRegistrySlide(1)">{{getString('clicking_here')}}</span>.</p>
							</div>
						</div>
						<div class="col-6 mobile-12 menu-dropzone-col">
							<p class="mb-16" v-show="!funnelStore.pollingMenuUpload">{{ getString('upload_your_x', [userStore.menuWord]) }}</p>
							<p class="mb-4" v-show="funnelStore.pollingMenuUpload">{{ getString('generating_result') }}</p>
							<StepsBottomSheetAIUpload :disabled="loadingRegistryStep" @upload-complete="menuFileUploadComplete" v-if="activeStepsBottomSheet" />
							<div v-show="!funnelStore.pollingMenuUpload" class="mobile-menu-description">
								<p class="mt-30"><b>{{getString('ai_registry_manual', [userStore?.menuWord])}}</b></p>
								<p>{{getString('ai_registry_manual_cta')}} <span class="clickable-span" @click="changeRegistrySlide(1)">{{getString('clicking_here')}}</span>.</p>
							</div>
						</div>
					</div>
				</template>
				<template v-slot:manual-add-menu>
					<StepsBottomSheetVideoRow :video="item.video">
						<div class="col-12">
							<p v-html="getString('funnel_counter_registry_text', userStore?.menuWord)" />
							<div class="row mt-20 align-end">
								<AppButton v-show="!item.completed || funnelStore.errorMenuUpload" :disabled="(item.completed && !funnelStore.errorMenuUpload) || loadingRegistryStep" :text="getString('go_to_x', [userStore.menuWord])" @click="goToMenuCreateCategory" />
								<span v-show="registryPages?.length === 2" class="ml-10 mt-6 clickable-span small" @click="changeRegistrySlide(0)">{{ getString('or_do_it_via_ai') }}</span>
								<div v-show="registryPages?.length === 2" class="icon-ai blue" v-html="getIcon('iconAi')"></div>
							</div>
							<div v-show="!item.completed || funnelStore.errorMenuUpload" class="links-title">
								<div v-html="getIcon('link')"></div>
								<h6>{{ getString('useful_links') }}</h6>
							</div>
							<ul v-show="!item.completed || funnelStore.errorMenuUpload" style="list-style-position: outside" class="pl-20 link-step">
								<li><a target="_blank" href="https://qromo-help.freshdesk.com/support/solutions/articles/202000076459-anagrafica-prodotti">{{ getString('funnel_counter_registry_useful_link') }}</a></li>
								<li><a target="_blank" href="https://qromo-help.freshdesk.com/support/solutions/folders/202000246525">{{ getString('funnel_counter_registry_discover') }}</a></li>
							</ul>
							<div v-show="item.completed && !funnelStore.errorMenuUpload" class="status-message-success mt-20">
								<p>{{ getString('completed_registry') }}</p>
							</div>
						</div>
					</StepsBottomSheetVideoRow>
				</template>
			</AppPagination>
		</template>
		<template #room-creation="{item}">
			<div class="col-12">
				<p v-html="getString('rooms_creation_text')"></p>
				<br>
				<p><b>{{ getString('rooms_creation_cta_text') }}</b></p>
				<div class="row m-20">
					<div class="col-12 gap-10">
						<AppTextInput @pressed-enter="createNewRoom" @changing-text="v => newRoomName = v" :placeholder="getString('room_name')" :class="{disabled: item.completed}" :readonly="item.completed" />
						<AppNumberInput @pressed-enter="createNewRoom" @changed-value="v => newRoomTables = v" :label="getString('how_many_tables')" :class="{disabled: item.completed}" :min="0" :max="200" />
						<AppButton class="mt-10" :disabled="item.completed" :paused="loadingRoomStep" :text="getString('create_room')" @click="createNewRoom"/>
					</div>
				</div>
			</div>
		</template>
		<template #link-creation="{item}">
			<div class="col-12">
				<p>{{ getString('link_creation_text', [userStore.menuWord]) }}</p>
				<div class="row m-20">
					<div class="col-12 gap-10">
						<AppTextInput v-show="!item.completed" :value="userStore?.currBusiness?.link || ''" @pressed-enter="createLinkAndQr" @changing-text="v => newBusinessLink = v" :placeholder="getString('link_placeholder_events')" :class="{disabled: item.completed}" :readonly="!!userStore?.currBusiness?.link || item.completed" />
						<AppButton v-show="!item.completed" class="mt-10" :disabled="item.completed" :paused="loadingRoomStep" :text="getString('create_qr')" @click="createLinkAndQr"/>
						<div class="status-message-success" v-show="item.completed">
							<p>{{getString('qr_and_link_set', [currentLink])}}</p>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template #events-video="{item}">
			<div class="col-12 centered">
				<iframe class="events-video-iframe" :width="videoMeasurements.W" :height="videoMeasurements.H" src="https://www.youtube.com/embed/3H45HKva6O0?rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
				<div class="events-video-btn-container">
					<AppButton v-show="!item.completed" @click="clickContinueEventsVideo" class="mt-30" :disabled="!eventsVideoTimerEnded"  :text="getString('continue')" />
				</div>
			</div>
		</template>
		<template #go-live="{goLiveItem}">
			<AppPopup ref="popup-confirm-new-plan" :title="getString('change_plan')" :body-text="getString('change_plan_confirm', [getString('qromo_'+userStore.currSubscription), getString('qromo_'+newTargetPlan)])" :buttons="[{text: getString('cancel'), negative: true, loading: loadingNewPlan}, {text: getString('continue'), callback: switchToNewPlan, loading: loadingNewPlan}]" />
			<MarketplaceNewSubscriptionCards funnel :loading="loadingNewPlan" @switch-plan="openSwitchToNewPlanPopup" @checkout="startCheckout" />
			<CheckoutInPlace :client-secret="clientSecret" @toggling-popup="togglingPopupCheckout" @checkout-complete="refreshBusiness" />
		</template>
		<template #receive-payments="{item}">
			<StepsBottomSheetVideoRow :video="item.video">
				<div class="col-12">
					<h5>{{ getString('funnel_stripe_title') }}</h5>
					<p class="receive-payments-text" v-html="getString('funnel_stripe_text')"></p>
					<div class="row mt-20">
						<div class="col-12 align-start" v-if="(userStore.currBusiness.stripe_account && userStore.currBusiness.config_payments)">
							<div class="status-message-success mb-20">
								<p>{{getString('stripe_linked')}}</p>
							</div>
						</div>
						<AppButton
							v-else-if="userStore.currBusiness.stripe_account && !userStore.currBusiness.config_payments"
							@click="connectStripe"
							:loading="loadingConnectStripe"
							:text="getString('connect_stripe_account')"
							:disabled="item.completed"
						/>
						<AppButton
							v-else
							@click="connectStripe"
							:loading="loadingConnectStripe"
							:text="getString('connect_stripe_account')"
							:disabled="item.completed"
						/>
					</div>
				</div>
			</StepsBottomSheetVideoRow>
		</template>
	</FunnelStepsBottomSheet>
	<AppBottomSheet :active="showStripeOnboarding" @toggling-popup="toggleStripeOnboardingSheet" :force-width="bottomSheetWidth">
		<div id="stripe-onboarding-container-funnel"></div>
	</AppBottomSheet>
</template>

<script>
import {useShopStore} from "@/shop/stores";
import { useLanguageStore, useCurrencyStore, useSvgStore, useNotificationStore } from "@/shared/stores";
import { useUserStore, useAdministrationStore, useRoomsStore, useMenuStore, useFunnelStore } from "@/console-new/stores";
import FunnelStepsBottomSheet from "@/console-new/components/shared/FunnelStepsBottomSheet.vue";
import StepsBottomSheetAIUpload from "@/console-new/components/shared/StepsBottomSheetAIUpload.vue";
import StepsBottomSheetVideoRow from "@/console-new/components/shared/StepsBottomSheetVideoRow.vue";
import StepsBottomSheetChecklist from "@/console-new/components/shared/StepsBottomSheetChecklist.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppNumberInput from "@/shared/components/AppNumberInput.vue";
import FunnelVideoCard from "@/console-new/components/shared/FunnelVideoCard.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import MarketplaceNewSubscriptionCards from "@/console-new/components/plugins/MarketplaceNewSubscriptionCards.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import API from "@/shared/helpers/API";
import CheckoutInPlace from "@/console-new/components/shared/CheckoutInPlace.vue";
import AppPagination from "@/shared/components/AppPagination.vue";
import AppLoader from "@/shared/components/AppLoader.vue";
import AppDropzone from "@/shared/components/AppDropzone.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import {getRandomAlphanumericString} from "@/shared/helpers/strings";
import AppProgressBar from "@/shared/components/AppProgressBar.vue";

export default {
	setup() {
		const userStore = useUserStore();
		const funnelStore = useFunnelStore();
		const languageStore = useLanguageStore();
		const svgStore = useSvgStore();
		const administrationStore = useAdministrationStore();
		const notificationStore = useNotificationStore();
		const roomsStore = useRoomsStore();
		const menuStore = useMenuStore();
		const shopStore = useShopStore();
		const currencyStore = useCurrencyStore();
		return { userStore, roomsStore, currencyStore, menuStore, shopStore, funnelStore, getIcon: svgStore.get, showNotification: notificationStore.showNotification, administrationStore, getString: languageStore.getString };
	},
	name: "StepsBottomSheet",
	mixins: [WindowWidth],
	components: {
		AppProgressBar,
		AppDropzone, AppTextInput, AppNumberInput, AppLoader,
		AppPagination,
		CheckoutInPlace,
		AppPopup,
		AppChevronIcon,
		AppButton,
		FunnelStepsBottomSheet,
		MarketplaceNewSubscriptionCards,
		FunnelVideoCard,
		StepsBottomSheetChecklist,
		StepsBottomSheetVideoRow,
		StepsBottomSheetAIUpload,
		AppBottomSheet
	},
	data() {
		return {
			clientSecret: null,
			loadingCancelFunnel: false,
			loadingConnectStripe: false,
			activeStepsBottomSheet: false,
			newTargetPlan: null,
			fromPlan: null,
			toPlan: null,
			changeCycle: false,
			loadingNewPlan: false,
			showStripeOnboarding: false,
			embeddedOnboardingComponent: null,
			loadingRegistryStep: false,
			imagesWaitingGeneration: 0,
			elementsToGenerateImage: 0,
			newRoomName: null,
			newRoomTables: 0,
			newBusinessLink: null,
			loadingRoomStep: false,
			eventsVideoTimer: null,
			eventsVideoTimerEnded: false,
			sendingEventsVideoStepProgress: false,
		}
	},
	computed: {
		currentLink() {
			let link = this.userStore?.currBusiness?.link || '';
			link += typeof HOST !== 'undefined' ? ('.' + HOST) : '';
			return link;
		},
		videoMeasurements() {
			let ratio = 1.5;
			let width = this.windowWidth < 550 ? 400 : this.windowWidth - 200;
			width = width > 750 ? 750 : width;
			let height = this.windowWidth < 550 ? 300 : Math.round(width / ratio);

			return {
				W: width,
				H: height
			}
		},
		registryPages() {
			let pages = [];
			if(this.funnelStore.pollingMenuUpload || !this.menuStore?.categories || Object.keys(this.menuStore.categories).length === 0) {
				pages.push({id: 'ai', slotName: 'ai-add-menu'});
			}
			pages.push({id: 'manual', slotName: 'manual-add-menu'});
			return pages;
		},
		bannerData() {
			return this.funnelStore.currFunnel?.bannerData || null;
		},
		stepperSteps() {
			return this.funnelStore.currFunnel?.steps || [];
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else if(this.windowWidth < 1080) {
				return "720px";
			} else {
				return "960px";
			}
		},
		completingPercent() {
			if(!this.imagesWaitingGeneration) {
				return 100;
			}
			let percent = 100 - Math.round((this.imagesWaitingGeneration / (this.elementsToGenerateImage || 1)) * 100);
			percent = percent >= 100 ? 100 : percent;
			return percent <= 5 ? 5 : percent;
		},
		hasRoomWithQr() {
			return this.roomsStore?.rooms?.length && this.roomsStore.rooms.some(r => !!r.type);
		},
	},
	methods: {
		startEventsVideoTimer() {
			if(this.eventsVideoTimer) {
				clearTimeout(this.eventsVideoTimer);
				this.eventsVideoTimer = null;
			}
			this.eventsVideoTimer = setTimeout(() => {
				this.eventsVideoTimerEnded = true;
			}, 30000);
		},
		clickContinueEventsVideo() {
			if(!this.eventsVideoTimerEnded || this.sendingEventsVideoStepProgress) {
				return;
			}
			this.sendingEventsVideoStepProgress = true;
			this.funnelStore.updateBusinessFunnelProgress(this.funnelStore.STEP_VIDEO, () => {
				this.sendingEventsVideoStepProgress = false;
			});
		},
		createLinkAndQr() {
			if(this.loadingRoomStep) {
				return;
			}
			if(document.activeElement) {
				document.activeElement.blur();
			}
			if(!this.newBusinessLink && !this.userStore.currBusiness.link) {
				this.showNotification("link-invalid");
				return;
			}
			this.loadingRoomStep = true;
			let createRoomFn = (nextAction) => {
				this.roomsStore.getBusinessRooms(() => {
					if(!this.hasRoomWithQr) {
						//No rooms at all, should create one and set qr per name
						if (!this.roomsStore.rooms?.length) {
							this.createNewRoomForQr(nextAction);
						} else {
							//Already has room, should create qr
							nextAction();
						}
					} else {
						//Step is complete
						this.showNotification('generic-success');
						this.loadingRoomStep = false;
						this.$router.push('/config/qrcode');
					}
				})
			}
			let createQrFn = (roomId) => {
				let foundRoom = this.roomsStore.rooms.length && this.roomsStore.rooms.find(r => !!r.room_id && !r.type);
				if(!foundRoom) {
					//No room to assign the qr code
					this.showNotification('generic-fail');
					this.loadingRoomStep = false;
					return;
				}
				//Setting qr per name
				API.init().updateRoomType(this.userStore.currBusinessId, foundRoom.room_id, 'customer_name', (resp) => {
					if(resp && resp.result && resp.result === "OK") {
						this.userStore.currBusiness.config_tables = true;
						this.showNotification('generic-success');
						this.$router.push('/config/qrcode');
						this.roomsRefresh(roomId);
					} else {
						this.showNotification('generic-fail');
					}
					this.loadingRoomStep = false;
				});
			}

			if(!this.userStore.currBusiness.link) {
				this.saveLink(()=>{
					createRoomFn(createQrFn);
				});
			} else {
				createRoomFn(createQrFn);
			}
		},
		saveLink(callback) {
			let link = this.newBusinessLink;
			if(link.length > 2 && link.match(/^[a-z0-9]+$/i) !== null) {
				this.userStore.createLinkBusiness(link,(success, details) => {
					if (success) {
						if(callback) {
							callback();
						} else {
							this.showNotification("generic-success");
						}
					} else {
						if(details === "already_exists") {
							this.showNotification("link-already-exists");
						} else if(details === "not_editable") {
							this.showNotification("link-not-editable");
						} else {
							this.showNotification("generic-fail");
						}
						this.loadingRoomStep = false;
					}
				});
			} else {
				this.showNotification("link-invalid");
				this.loadingRoomStep = false;
			}
		},
		shouldAbortAiUpload() {
			return this.funnelStore?.aiUploadBusinessId !== this.userStore?.currBusinessId;
		},
		createNewRoomForQr(callback) {
			let newRoomName = this.userStore.currBusiness.name || this.getString('new_room');

			let tableElements = [{
				id: getRandomAlphanumericString(10),
				name: this.getString('online'),
				editFrom: false,
				from: 1,
				editTo: false,
				to: 1,
				people: 0,
				editPeople: false,
			}]

			API.init().addRoom(this.userStore.currBusinessId, newRoomName, true, false, JSON.stringify(tableElements), (response) => {
				if(response && response.result && response.result === "OK") {
					let roomId = response.room_id ? Number(response.room_id) : null;
					this.roomsRefresh(roomId, callback);
				} else {
					this.showNotification('generic-fail');
					this.loadingRoomStep = false;
				}
			});
		},
		createNewRoom() {
			if(this.loadingRoomStep) {
				return;
			}
			if(document.activeElement) {
				document.activeElement.blur();
			}
			if(!this.newRoomName?.length) {
				this.showNotification('invalid-name');
				return;
			}
			if(this.newRoomTables <= 0) {
				this.showNotification('no-elements-error');
				return;
			}
			if(this.newRoomTables > 200) {
				this.showNotification('too-many-elements-error');
				return;
			}

			let tableElements = [{
				id: getRandomAlphanumericString(10),
				name: this.getString('table'),
				editFrom: false,
				from: 1,
				editTo: false,
				to: this.newRoomTables,
				people: 0,
				editPeople: false,
			}]
			this.loadingRoomStep = true;
			API.init().addRoom(this.userStore.currBusinessId, this.newRoomName, true, false, JSON.stringify(tableElements), (response) => {
				if(response && response.result && response.result === "OK") {
					this.roomsRefresh(response.room_id ? Number(response.room_id) : null);
					this.showNotification('generic-success');
					this.$router.push('/config/qrcode');
				} else {
					this.showNotification('generic-fail');
				}
				this.loadingRoomStep = false;
			});
		},
		roomsRefresh(roomId, cb) {
			let sendEvent = false;
			if(this.funnelStore?.currStep?.trackEventId && this.funnelStore?.currStep?.trackEventId.startsWith('step2_') && !this.roomsStore?.rooms?.length) {
				sendEvent = this.funnelStore?.currStep?.trackEventId;
			}
			this.roomsStore.getBusinessRooms(() => {
				if(this.roomsStore.rooms.length > 0) {
					if(!!sendEvent) {
						this.funnelStore.updateBusinessFunnelProgress(this.funnelStore.STEP_ROOMS);
					}
					let room = roomId ? this.roomsStore.rooms.find(r => r.room_id === roomId) : null;
					if(room) {
						this.roomsStore.setActiveRoom(room.room_id);
					}
					if(cb) {
						cb(roomId);
					}
				}
			}, true);
		},
		increaseAiProgress(maxPercentage = 50) {
			let finalPercentage = Math.min(maxPercentage, 100);
			if((this.funnelStore?.aiProgress || 0) < finalPercentage) {
				this.funnelStore.aiProgress = (this.funnelStore?.aiProgress || 0) + 1;
			}
		},
		aiProgressTimeout(maxPercentage = 50) {
			if(this.shouldAbortAiUpload()) {
				this.resetUploadMenuParams();
				return
			}
			if(!this.funnelStore?.pollingMenuUpload) {
				return
			}
			let finalPercentage = Math.min(maxPercentage, 100);
			setTimeout(()=>{
				this.increaseAiProgress(maxPercentage);
				if(this.funnelStore?.aiProgress < finalPercentage) {
					this.aiProgressTimeout(maxPercentage);
				}
			}, this.getRandomTimeout());
		},
		getRandomTimeout() {
			let maxTime = 960;
			let minTime = 220;
			let randomTime = Math.floor(Math.random() * maxTime);
			return randomTime < minTime ? minTime : randomTime;
		},
		menuFileUploadComplete(urls){
			let url = urls[0];
			this.funnelStore.pollingMenuUpload = true;
			this.funnelStore.aiUploadBusinessId = this.userStore.currBusinessId;

			setTimeout(() => {
				this.funnelStore.aiProgress = 1;

				API.init().decodeMenuFile(this.userStore.currBusinessId, url, (response) => {
					if(response && response.result && response.result === "OK" && response.ai_menu_log_id) {
						this.startRunPolling(response.ai_menu_log_id);
					} else if(response && response?.generating?.ai_menu_log_id) {
						this.showNotification("already-generating-menu", [this.userStore.menuWord]);
						this.startRunPolling(response.generating.ai_menu_log_id);
					} else {
						this.funnelStore.errorMenuUpload = true;
						this.funnelStore.pollingMenuUpload = false;
						this.funnelStore.aiUploadBusinessId = null;
						this.showNotification(response?.details === 'rate_limit' ? "menu-fail-rate-limit" : "generic-fail");
						if(response?.details === 'rate_limit') {
							this.changeRegistrySlide(1);
						}
					}
				});
			}, 550);
		},
		startRunPolling(aIMenuLogId) {
			if(this.shouldAbortAiUpload()) {
				this.resetUploadMenuParams();
				return
			}
			API.init().checkMenuRun(this.userStore.currBusinessId, aIMenuLogId, (response) => {
				if(this.shouldAbortAiUpload()) {
					this.resetUploadMenuParams();
					return
				}
				if(response && response.result && response.result === "OK" && response.run_result) {
					if(response.run_result.status === "failed") {
						this.showNotification("generic-fail");
						this.funnelStore.pollingMenuUpload = false;
						this.funnelStore.aiUploadBusinessId = null;
					} else if(response.run_result.status === "completed") {
						this.analyzeResults(response.run_result.result);
					} else {
						setTimeout(() => {
							this.startRunPolling(aIMenuLogId);
						}, 3000);
					}
				} else {
					this.showNotification("generic-fail");
					this.funnelStore.pollingMenuUpload = false;
					this.funnelStore.aiUploadBusinessId = null;
				}
			});

		},
		analyzeResults(runResult) {
			if(this.shouldAbortAiUpload()) {
				this.resetUploadMenuParams();
				return
			}
			let result = runResult.split("\n");
			let noise = [];
			let items = [];

			for(let i = 0; i < result.length; i++) {
				let line = result[i];
				if(line.includes("|")) {
					let item = line.split("|");
					if(item.length === 4) {
						items.push({
							category: item[0].trim(),
							name: item[1].trim(),
							price: this.parsePrice(item[2].trim()),
							description: item[3].trim(),
						});
					} else {
						noise.push(this.$sanitize(line));
					}
				} else {
					noise.push(this.$sanitize(line));
				}
			}

			if(!items?.length) {
				this.showNotification("funnel-menu-load-fail", [this.userStore.menuWord]);
				this.funnelStore.errorMenuUpload = true;
				this.funnelStore.pollingMenuUpload = false;
				this.funnelStore.aiUploadBusinessId = null;
			} else {
				this.addItemsToMenu(items)
			}

		},
		parsePrice(price) {
			let priceString = price.replace(",", ".").replace("€", "").replace("EUR", "").replace("eur", "").replace("$", "").replace("USD", "").replace("usd", "").trim();
			for(let currency in this.currencyStore.currencies) {
				let currencySymbol = this.currencyStore.currencies[currency].symbol;
				let currencyCode = this.currencyStore.currencies[currency].code;
				priceString = priceString.replace(currencySymbol, "").replace(currencyCode, "").replace(currencyCode.toLowerCase(), "").trim();
			}
			let priceFloat = parseFloat(priceString);
			if(isNaN(priceFloat)) {
				return 0;
			} else {
				return Number((priceFloat* 100).toFixed(0));
			}
		},
		addItemsToMenu(items) {
			if(this.shouldAbortAiUpload()) {
				this.resetUploadMenuParams();
				return
			}
			if(items.length === 0) {
				this.funnelStore.errorMenuUpload = true;
				this.funnelStore.pollingMenuUpload = false;
				this.funnelStore.aiUploadBusinessId = null;
				return;
			}

			let categories = {};
			for(let i = 0; i < items.length; i++) {
				let item = items[i];
				if(!categories[item.category]) {
					let newCategory = this.menuStore.addNewCategory({name: item.category});
					newCategory.editActive = false;
					newCategory.editActiveDelayed = false;
					categories[item.category] = newCategory.tempid;
				}
			}

			this.menuStore.saveCategories((success, details) => {
				if(success) {
					for(let i = 0; i < items.length; i++) {
						let item = items[i];
						if(categories.hasOwnProperty(item.category)) {
							let newItem = this.menuStore.addNewItem(categories[item.category], {
								name: item.name,
								price: item.price,
								ingredients: item.description,
							});
							newItem.active = false;
							newItem.collapsedDelayed = true;
						}
					}
					this.menuStore.saveMenu(()=>{
						this.menuStore.refreshMenusData(()=>{
							let targetMenu = this.menuStore?.modMenu || {};
							if(this.menuStore.itemsNum < 3 || !targetMenu?.canGenerateImages) {
								setTimeout(()=>{
									if(this.menuStore.itemsNum < 3) {
										this.funnelStore.errorMenuUpload = true;
									}
									this.funnelStore.pollingMenuUpload = false;
									this.funnelStore.aiUploadBusinessId = null;
								}, 200)
							} else {
								localStorage.setItem('menu-upload-complete', this.userStore.currBusinessId.toString());
								this.funnelStore.completedMenuUpload = Number(this.userStore.currBusinessId);
								this.generateMenuImages();
							}
						})
					})
				} else {
					this.showNotification("funnel-menu-load-fail", [this.userStore.menuWord]);
					this.funnelStore.errorMenuUpload = true;
					this.funnelStore.pollingMenuUpload = false;
					this.funnelStore.aiUploadBusinessId = null;
				}
			});
		},
		generateMenuImages() {
			if(this.shouldAbortAiUpload()) {
				this.resetUploadMenuParams();
				return
			}
			this.elementsToGenerateImage = 0;
			let categoriesIds = [];
			let targetMenu = this.menuStore?.modMenu || {};
			if(targetMenu && targetMenu.categories) {
				for(let cat in targetMenu.categories) {
					let category = targetMenu.categories[cat];
					if(category?.menu_category_id) {
						categoriesIds.push(category?.menu_category_id);
						if(!category?.picture && !!category?.name) {
							this.elementsToGenerateImage += 1;
						}
						if(category.items) {
							for(let it in category.items) {
								let item = category.items[it];
								if(!item?.picture && !!item?.name) {
									this.elementsToGenerateImage += 1;
								}
							}
						}
					}
				}
			}
			if(!categoriesIds.length) {
				this.funnelStore.pollingMenuUpload = false;
				this.funnelStore.aiUploadBusinessId = null;
				return;
			}
			this.getImagesUpdates(success=>{
				if(this.shouldAbortAiUpload()) {
					this.resetUploadMenuParams();
					return;
				}
				if(success) {
					this.menuStore.saveMenu(()=>{
						if(this.shouldAbortAiUpload()) {
							this.resetUploadMenuParams();
							return;
						}
						API.init().generateMenuPictures(this.userStore.currBusinessId, this.menuStore.modMenu.menu_id, categoriesIds, {}, resp => {
							if(resp && resp?.result === 'OK') {
								this.funnelStore.aiProgress = 2;
								//start polling for images generation
								setTimeout(this.fetchGeneratingItems, 5000);
							} else {
								this.funnelStore.pollingMenuUpload = false;
								this.funnelStore.aiUploadBusinessId = null;
							}
						});
					})
				} else {
					this.funnelStore.pollingMenuUpload = false;
					this.funnelStore.aiUploadBusinessId = null;
				}
			})
		},
		getImagesUpdates(callback) {
			if(this.shouldAbortAiUpload()) {
				this.resetUploadMenuParams();
				return;
			}
			API.init().getMenuAIImagesUpdates(this.userStore.currBusinessId, res=>{
				if(this.shouldAbortAiUpload()) {
					this.resetUploadMenuParams();
					return;
				}
				if(res && res?.result === 'OK') {
					this.imagesWaitingGeneration = Number(res?.remaining || 0);
					if(!!this.imagesWaitingGeneration) {
						this.aiProgressTimeout(this.completingPercent);
						setTimeout(this.fetchGeneratingItems, 5000);
					} else if(callback) {
						callback(true);
					}
				} else {
					callback(false);
				}
			}, err=>{
				callback(false);
			});
		},
		fetchGeneratingItems() {
			if(this.shouldAbortAiUpload()) {
				this.resetUploadMenuParams();
				return;
			}
			this.getImagesUpdates(success=>{
				if(success) {
					this.menuStore.refreshMenusData(()=>{
						this.funnelStore.aiProgress = 100;
						setTimeout(()=>{
							this.funnelStore.pollingMenuUpload = false;
							this.funnelStore.aiUploadBusinessId = null;
						}, 600)
					});
				} else {
					this.funnelStore.pollingMenuUpload = false;
					this.funnelStore.aiUploadBusinessId = null;
				}
			})
		},
		getGeneratingBusinessMenu() {
			this.loadingRegistryStep = true;
			API.init().getGeneratingBusinessMenu(this.userStore.currBusinessId, (response) => {
				if(response && response.result && response.result === "OK") {
					if(response.run_result) {
						if(response.run_result?.status === "failed") {
							//should show any error or just ignore?

						} else if(response.run_result?.status === "completed") {
							this.funnelStore.aiProgress = 0;
							this.funnelStore.pollingMenuUpload = true;
							this.funnelStore.aiUploadBusinessId = this.userStore.currBusinessId;
							this.aiProgressTimeout(1);
							this.analyzeResults(response.run_result.result);
						} else if(response?.ai_menu_log_id) {
							this.funnelStore.aiProgress = 0;
							this.funnelStore.pollingMenuUpload = true;
							this.funnelStore.aiUploadBusinessId = this.userStore.currBusinessId;
							this.aiProgressTimeout(1);
							setTimeout(() => {
								this.startRunPolling(response?.ai_menu_log_id);
							}, 3000);
						}
					} //else do nothing since no menu is already generating
				}
				this.loadingRegistryStep = false;
			});
		},
		changeRegistrySlide(newPos) {
			let pagination = this.$refs?.['registry-pagination'];
			if(pagination && pagination.changeSlide) {
				this.$refs['registry-pagination'].changeSlide(newPos);
			}
		},
		refreshBusiness() {
			setTimeout(() => {
				const subActive = this.userStore.currBusiness && this.userStore.currBusiness.plan_id;
				this.userStore.refreshBusiness(this.userStore.currBusinessId, () => {
					if(!subActive && this.userStore.currBusiness && this.userStore.currBusiness.plan_id) {

						let value = 0;
						if(this.userStore?.currSubscription && this.userStore?.currSubscription !== 'free') {
							let subPrices = this.currencyStore.currCurrency?.prices?.plans[this.userStore?.currSubscription];
							let finalVal = this.userStore.currBusiness.plan_cycle === 'month' ? subPrices?.month : (subPrices?.yearMonth * 12);
							value = Number(finalVal || 0);
						}

					}
				});
			}, 2000);
			setTimeout(() => {
				this.clientSecret = null;
			}, 2500);
		},
		togglingPopupCheckout(isOpen) {
			if (!isOpen) {
				this.clientSecret = null;
			}
		},
		startCheckout(secret, billingCycle, planName) {
			this.clientSecret = secret;

			let value = 0;
			if(planName && planName !== 'free') {
				let subPrices = this.currencyStore.currCurrency?.prices?.plans[planName];
				let finalVal = billingCycle === 0 ? (subPrices?.yearMonth * 12) : subPrices?.month;
				value = Number(finalVal || 0);
			}

		},
		openSwitchToNewPlanPopup(newPlan, changeCycle = false) {
			this.newTargetPlan = newPlan;
			this.changeCycle = changeCycle;
			this.$refs["popup-confirm-new-plan"].toggleStatus();
		},
		switchToNewPlan() {
			if(this.loadingNewPlan) {
				return;
			}
			if(this.$refs?.['card-slashed']) {
				this.$refs['card-slashed'].loading = true;
			}
			this.loadingNewPlan = true;
			API.init().stripeSubscriptionUpdate(this.userStore.currBusinessId, this.newTargetPlan, this.changeCycle, (r) => {
				if (r && typeof r === 'object' && r.result === 'OK') {
					setTimeout(() => {
						this.$refs["popup-confirm-new-plan"].toggleStatus(false);
						this.userStore.refreshBusiness(this.userStore.currBusinessId, () => {
							this.loadingNewPlan = false;
						});
					}, 1000);
				} else {
					this.$refs["popup-confirm-new-plan"].toggleStatus(false);
					if(r?.details === 'too_many_users') {
						let maxUsers = this.newTargetPlan === 'basic' ? 3 : 10;
						maxUsers = this.newTargetPlan === 'free' ? 1 : maxUsers;
						this.showNotification('too-many-users', [maxUsers]);
					} else if(r?.details === 'no_webhooks') {
						this.showNotification('no-webhooks-edit');
					} else if(r?.details === 'cannot_change_unpaid') {
						this.showNotification('cannot-change-update');
					} else if(r?.details === 'max_webhooks') {
						this.showNotification('max-webhooks-edit', [1]);
					} else if(r?.details === 'currency_mismatch') {
						this.showNotification('user-currency-mismatch', [this.userStore?.user?.name]);
					} else {
						this.showNotification('generic-fail');
					}
					this.loadingNewPlan = false;
				}
			});
		},
		parsedVideoForList(item) {
			let returningVideo = {...item.video};
			if(this.funnelStore?.currStep?.listItems) {
				for(let i in this.funnelStore.currStep.listItems) {
					let currSubStep = this.funnelStore.currStep.listItems[i];
					if(!currSubStep.completed) {
						returningVideo.start = currSubStep.videoStart || 0;
						returningVideo.end = currSubStep.videoEnd || 0;
						return returningVideo;
					}
				}
			}
			return returningVideo;
		},
        goToPath(item) {
            if(item?.routerTo) {
                this.activeStepsBottomSheet = false;
                this.$router.push(item.routerTo);
            }
        },
		connectStripe() {
			if(this.loadingConnectStripe) {
				return;
			}
			this.loadingConnectStripe = true;

			this.administrationStore.getStripeConnectInstance("onboarding", connectInstance => {

				this.loadingConnectStripe = false;
				if(connectInstance) {

					this.showStripeOnboarding = true;
					const container = document.getElementById('stripe-onboarding-container-funnel');
					this.embeddedOnboardingComponent = connectInstance.create("account-onboarding");
					this.embeddedOnboardingComponent.setOnExit(() => {
						this.showStripeOnboarding = false;
						this.loadingConnectStripe = true;
						this.userStore.refreshBusiness(this.userStore.currBusinessId, () => {
							this.loadingConnectStripe = false;
						});
					});
					container.appendChild(this.embeddedOnboardingComponent);
				} else {
					this.showStripeOnboarding = false;
					this.showNotification('generic-fail');
				}
			});
		},
		togglingStepsSheet(isOpen) {
			this.activeStepsBottomSheet = !!isOpen;
			if(!isOpen) {
				this.restoreScroll();
			}
		},
		restoreScroll() {
			let targetElement = this.$refs['steps-bottom-sheet'];
			if(targetElement && targetElement.restoreScrollOnElements) {
				targetElement.restoreScrollOnElements();
			}
		},
		goToMenuCreateCategory() {
			this.menuStore.shouldCreateCategory = true;
			this.goToMenu();
		},
		goToMenu() {
			this.activeStepsBottomSheet = false;
			this.$router.push('/config/menu');
		},
		goToShop() {
			this.activeStepsBottomSheet = false;
			this.funnelStore.wentToShop = true;
			this.shopStore.addItemToCart({id:'epsonprinter'}, 1)
			this.shopStore.showCart = true;
			this.$router.push('/plugins/shop/epsonprinter');
		},
		goToSettings() {
			this.userStore.shouldOpenBusinessInfo = true;
			this.activeStepsBottomSheet = false;
			this.$router.push('/config/settings/general');
		},
		toggleStripeOnboardingSheet(active) {
			if(!active) {
				if (this.embeddedOnboardingComponent) {
					const container = document.getElementById('stripe-onboarding-container-funnel');
					if (container && container.firstChild) {
						container.removeChild(container.firstChild);
					}
					this.embeddedOnboardingComponent = null;
				}
				this.showStripeOnboarding = false;
			}
		},
		resetUploadMenuParams() {
			this.funnelStore.aiProgress = 0;
			this.funnelStore.pollingMenuUpload = false;
			this.funnelStore.aiUploadBusinessId = null;
			this.funnelStore.errorMenuUpload = false;
		},
		getMobileOperatingSystem() {
			let userAgent = navigator?.userAgent || navigator?.vendor || window?.opera;
			// Windows Phone must come first because its UA also contains "Android"
			if (/windows phone/i.test(userAgent)) {
				return "Windows Phone";
			}
			if (/android/i.test(userAgent)) {
				return "Android";
			}
			if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
				return "iOS";
			}
			return "unknown";
		}
	},
	mounted() {
		let currStep = this.funnelStore?.currStep;
		if(currStep && currStep?.slotName === 'products-registry') {
			this.getGeneratingBusinessMenu();
		}

		if(currStep && currStep.slotName === 'events-video' && !currStep.completed) {
			this.startEventsVideoTimer();
		} else if(this.eventsVideoTimer) {
			clearTimeout(this.eventsVideoTimer);
			this.eventsVideoTimer = null;
		}
	},
	beforeUnmount() {
		if (this.eventsVideoTimer) {
			clearTimeout(this.eventsVideoTimer);
			this.eventsVideoTimer = null;
		}
	},
	watch: {
		registryPages(newVal) {
			if(newVal && newVal.length && newVal.length === 1) {
				this.changeRegistrySlide(0);
			}
		},
		activeStepsBottomSheet(newVal) {
			if(newVal && this.funnelStore.currStep?.slotName === 'receive-payments' && !this.funnelStore.currStep.completed) {
				this.funnelStore.startPollingForStripeLink();
			} else if(!newVal) {
				clearTimeout(this.funnelStore.pollingTimeout);
			}
		},
		"funnelStore.currStep"(newStep) {
			if(newStep && newStep.slotName === 'receive-payments' && !newStep.completed) {
				this.funnelStore.startPollingForStripeLink();
			}
			if(newStep && newStep.slotName === 'events-video' && !newStep.completed) {
				this.startEventsVideoTimer();
			} else if(this.eventsVideoTimer) {
				clearTimeout(this.eventsVideoTimer);
				this.eventsVideoTimer = null;
			}
		},
		"userStore.currBusinessId"(newId, oldId) {
			if(newId && newId !== oldId) {
				this.newBusinessLink = null;
				this.newRoomName = null;
				this.newRoomTables = 0;
				this.loadingRoomStep = false;
				this.funnelStore.showEventsPhysicalManual = false;
				this.funnelStore.completedMenuUpload = Number(localStorage.getItem("menu-upload-complete") || 0) || null;
				this.resetUploadMenuParams();
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.go-back-button.base-button.outline, .hide-guided-steps-button.base-button.outline {
	border: none;
}
.hide-guided-steps-button.base-button.outline:deep(.btn-text p) {
	color: var(--txt-1);
}
.link-step {
	li {
		margin-bottom: 5px;
		&::marker {
			color: var(--color-primary);
		}
		a {
			&:after {
				display: none;
			}
		}
	}
}
.links-title {
	@include centered;
	justify-content: flex-start;
	margin: 10px 0 5px;

	div, h6 { display: inline; }
	h6 { color: var(--color-txt-2) }
	div {
		margin-right: 5px;

		:deep(.fill) {
			fill: var(--color-txt-2);
		}
		:deep(.stroke) {
			stroke: var(--color-txt-2);
		}
	}
}
.cta-step-container {
	padding: 16px 0 20px 32px;
	min-height: 100px;

	.cta-step-text {
		font-size: 14px;
		line-height: 16px;
		margin-bottom: 12px;
	}

	.cta-step-button {
		margin-left: auto;
	}
	.warning-message {
		padding: 10px;
		margin-bottom: 20px;
		border-radius: 13px;
		background: var(--color-alpha-1);
	}
}
.receive-payments-text {
	font-size: 14px;
}
.fiscalization-card {
	display: flex;
	border-radius: 12px;
	padding: 10px;
	background-color: var(--color-alpha-1);

	.fiscalization-card-image {
		@include centered;
		width: 100px;

		img {
			width: 100%;
			border-radius: 12px;
		}
	}
	.fiscalization-card-content {
		padding-left: 10px;
		width: calc(100% - 100px);

		h4 {
			font-style: normal;
			color: $primary;
		}
		p {
			font-size: 14px;
			line-height: 18px;
		}
	}

	@media (max-width: 768px) {
		.fiscalization-card-image {
			width: 120px;
		}
		.fiscalization-card-content {
			width: calc(100% - 120px);
		}
	}

	@media (max-width: 400px) {
		flex-direction: column;
		.fiscalization-card-image {
			margin-bottom: 10px;
		}
		.fiscalization-card-content {
			padding-left: 0;
			width: 100%;
		}
	}
}

.fiscalization-links-title {
	margin-top: 20px;
}
.fiscalization-first-col {
	padding-right: 20px;
	@media (max-width: 768px) {
		margin-bottom: 30px;
		padding-right: 0;
	}
}
.fiscalization-row {
	margin-bottom: 20px;
	.fiscalization-first-col {
		padding-right: 0;
	}
	@media (min-width: 769px) {
		gap: 40px;
		& > .col-6 {
			width: calc(50% - 20px);
			max-width: calc(50% - 20px);
		}
	}
}
.contact-fiscal {
	padding: 10px;
	border-top: 1px solid var(--color-border-1);

	a.no-underline:after {
		display: none;
	}
}
.clickable-span {
	cursor: pointer;
	text-decoration: underline;
	color: var(--color-primary);
	&.small {
		font-size: 14px;
	}
}
.menu-dropzone-col {
	align-items: center;
}
.desktop-menu-description {
	display: block;
}
.mobile-menu-description {
	display: none;
}
.icon-ai {
	height: 16px;
	:deep(svg) {
		max-height: 100%;
		max-width: 100%;
	}
	:deep(.fill) {
		fill: var(--txt-0);
	}
	:deep(.stroke) {
		stroke: var(--txt-0);
	}

	&.blue {
		height: 14px;
		margin-bottom: 8px;
		:deep(.fill) {
			fill: var(--color-primary);
		}
		:deep(.stroke) {
			stroke: var(--color-primary);
		}
	}
}

@media (max-width: 768px) {
	.menu-dropzone-col {
		align-items: flex-start;
	}
	.desktop-menu-description {
		display: none;
	}
	.mobile-menu-description {
		display: block;
	}
}
#stripe-onboarding-container-funnel {
	min-height: 150px;
	padding: 3px 4px;
	overflow: hidden;
	margin: 0 auto;
}
.events-video-iframe {
	max-width: 100%;
	border-radius: 16px;
}
.events-video-btn-container {
	@include centered;
	flex-direction: column;
	width: 120px;
}
.status-message-success {
	border: 1px solid #0C9A72;
	border-radius: 20px;
	padding: 5px 10px;
	width: fit-content;
}
</style>